import { Component, Inject, OnInit } from '@angular/core';
import { AutoEvaluacionComponent } from '../../auto-evaluacion.component';

@Component({
  selector: 'app-verificacion-seguimiento',
  templateUrl: './verificacion-seguimiento.component.html',
  styleUrls: ['./verificacion-seguimiento.component.css']
})
export class VerificacionSeguimientoComponent implements OnInit {

  ngOnInit(): void {
  }


}

